export const OPEN_DELAY = 300;